import { useContext, useCallback, useMemo } from "react";
import { TasksContext } from "../../context/tasks/store";
import { TasksManager } from "./TasksManager.component";
import type { COFFRET } from "../../api/coffrets";
import { exportCsvAll, resetEtiquettesCsv } from "../../api/coffrets";

const headers = [
  "NUM_AUTO",
  "LIGNE_1",
  "LIGNE_2",
  "LIGNE_3",
  "LIGNE_4",
  "LIGNE_5",
  "LIGNE_6",
  "LIGNE_7",
  "LIGNE_8",
  "LIGNE_9",
  "LIGNE_10",
];

const arr = <T,>(v: any): T[] => (Array.isArray(v) ? v : []);

export const TasksManagerContainer = () => {
  const {
    search,
    setSearch,
    setIsModalOpen,
    setCoffretToUpdate,
    data,
    coffretsToCsv,
    resetCoffretsToCsv,
  } = useContext(TasksContext);

  const handleSearch = useCallback(
    (e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement | HTMLSelectElement>) =>
      setSearch(e.target.name, e.target.value),
    [setSearch]
  );

  const openModal = useCallback(() => {
    setCoffretToUpdate(null);
    setIsModalOpen();
  }, [setCoffretToUpdate, setIsModalOpen]);

  const safeCsv = arr<COFFRET>(coffretsToCsv);

  const newValues = useMemo(
    () =>
      safeCsv.map((item: any, index: number) => ({
        NUM_AUTO: index + 1,
        LIGNE_1: item?.sexe ?? "",
        LIGNE_2: item?.genre ?? "",
        LIGNE_3: item?.espece ?? "",
        LIGNE_4: item?.detailsCapture ?? "",
        // ✅ colonne 5 toujours vide
        LIGNE_5: "",
        LIGNE_6: item?.dateCapture ?? "",
        LIGNE_7: item?.faune ?? "",
        LIGNE_8: item?.numeroOrdre ?? "",
        LIGNE_9: "",
        LIGNE_10: "",
      })),
    [safeCsv]
  );

  const csvReport = useMemo(
    () => ({
      data: newValues,
      headers,
      filename: "ETIQUETTES.csv",
    }),
    [newValues]
  );

  // ✅ Export = téléchargement du fichier UNIQUE ETIQUETTES.csv
  const onExportAllCsv = useCallback(async () => {
    await exportCsvAll();
  }, []);

  // ✅ Reset queue côté serveur + reset sélection locale
  const onResetCsv = useCallback(async () => {
    const resp = await resetEtiquettesCsv();
    if (!resp.ok) {
      console.warn("[ETIQUETTES reset] FAILED:", resp.status, resp.message);
      return;
    }
    resetCoffretsToCsv();
  }, [resetCoffretsToCsv]);

  return (
    <TasksManager
      handleModal={openModal}
      handleChangeSearch={handleSearch}
      search={search}
      data={data}
      coffretsToCsv={safeCsv}
      csvReport={csvReport}
      resetCoffretsToCsv={onResetCsv}
      onExportAllCsv={onExportAllCsv}
    />
  );
};